import classNames from 'classnames';
import React, { useState } from 'react';
import SidebarContent from './SidebarContent';

const Sidebar = (props) => {
    const {
        isSidebarShow,
        toggleSidebar
    } = props;

    const sidebarClass = classNames({
        'sidebar sidebar--no-desktop': true,
        'sidebar--show': isSidebarShow,
    });

    return (
        <div className={sidebarClass}>
            <button
                className="sidebar__back"
                type="button"
                onClick={() => {toggleSidebar()}}
                aria-hidden
            />
            <div className="sidebar__wrapper sidebar__wrapper--mobile">
                <SidebarContent 
                    isSidebarShow={isSidebarShow}
                    toggleSidebar={toggleSidebar} 
                />
            </div>
        </div>
    );
};

export default Sidebar;
